import { V2FleetType as ApiFleetType } from '@jucy/rentals-api-client/rentals-api-v3/models/V2FleetType';

export { FleetTypeCode } from '@jucy/rentals-api-client/rentals-api-v3/models/FleetTypeCode';

export interface FleetType extends ApiFleetType {
    thumbnail?: string;
    sortOrder: number;
}
